import template from './requestPasswordReset.html';
import controller from './requestPasswordReset.controller';

let requestPasswordResetComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default requestPasswordResetComponent;



// WEBPACK FOOTER //
// ./app/components/requestPasswordReset/requestPasswordReset.component.js